import axios from 'axios';
export const lookupAccount = (type, body) => {
    return axios.post(`belajar-id/account-lookup/v1/lookup/${type}`, body);
};
export const requestPassword = (body, method = 'email') => {
    return axios.post('belajar-id/account-lookup/v1/lookup/request-password', body, {
        params: { method },
        headers: {
            Authorization: `Bearer ${body.token}`,
        },
    });
};
export const changePrivateEmail = (token, email) => {
    return axios.post('belajar-id/account-lookup/v1/lookup/change-email', {
        email,
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};
export const requestAccountCreation = (type, payload) => {
    return axios.post(`belajar-id/account-lookup/v1/lookup/${type}/request-account-creation`, payload);
};
